import * as React from 'react';

/**
 * Full-width launch-pricing strip shown above the pricing cards. Copy is
 * claim-free (no invented deadline or percentage).
 */
export function PricingLaunchBanner(): React.JSX.Element {
  return (
    <div className="w-full bg-primary px-4 py-2.5 text-center text-sm text-primary-foreground">
      <p className="mx-auto max-w-4xl text-balance leading-relaxed">
        <span
          aria-hidden="true"
          className="mr-1.5"
        >
          ✦
        </span>
        <span className="font-medium">
          Launch pricing — your first 6 months at a discounted rate.
        </span>{' '}
        Locks in on signup, then renews at the standard rate.
      </p>
    </div>
  );
}
